import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { H1 } from '@hobs/components/Headings';
import Panel from '@hobs/components/Panel';
import './TermsAndConditionsView.scss';

import { getExerciseTerms } from '../../actions/exercises';

class TermsAndConditionsView extends PureComponent {
  constructor() {
    super();
    this.terms = React.createRef();
  }

  componentDidMount() {
    this.props.getExerciseTerms();
  }

  render() {
    const { t } = this.props;

    return (
      <div ref={this.terms} className="terms-and-conditions">
        <div className="terms-and-conditions--heading">
          <H1>{t('Terms and Conditions')}</H1>
        </div>
        <Panel>
          <div
            className="terms-and-conditions--panel-content"
            dangerouslySetInnerHTML={{ __html: this.props.page }}
          />
        </Panel>
      </div>
    );
  }
}

TermsAndConditionsView.propTypes = {
  page: PropTypes.string,
  history: PropTypes.object,
  getExerciseTerms: PropTypes.func,
  t: PropTypes.func
};

const mapStateToProps = state => ({
  page: state.exercises.currentTermPage
});

const mapDispatchToProps = {
  getExerciseTerms
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(TermsAndConditionsView)));
